import { useSelectorWithShallowEqual } from '@hooks/reduxHooks';
import { getIsLoggedIn } from '@selectors/auth';
import useUserSubscriptionType from '@hooks/useUserSubscriptionType';
import { resolveShowBuy } from '@utils/subscriptionHelpers/resolveShowBuy';
import useTestAccess from '../Details/Description/Actions/useSkuAccessForTest';

const useHideTestCTA = ({
  quizUID,
  isSpecial,
  isSubscribedUser,
  isStoreExclusive,
  goalUid,
  availableFor
}) => {
  const isLoggedIn = useSelectorWithShallowEqual(getIsLoggedIn);

  const skipsUamSubscribedGuard = isStoreExclusive ? false : isSubscribedUser;

  const { isTestAccessPresent, refetchUam, isUamValidating } = useTestAccess(
    quizUID,
    'Quiz:Join',
    'Quiz',
    skipsUamSubscribedGuard,
    isSpecial
  );

  const hasAccessForGate = isStoreExclusive
    ? isSpecial || isTestAccessPresent
    : isSpecial || isSubscribedUser || isTestAccessPresent;

  const userSubscriptionType = useUserSubscriptionType(goalUid);
  const hasAvailableForList =
    Array.isArray(availableFor) && availableFor.length > 0;
  // Only enforce the available_for tier-list check once it's actually
  // configured for the quiz. Without it, fall back to the plain
  // hasAccessForGate check so unmigrated store-exclusive quizzes behave
  // unchanged.
  // hideTestCTA historically means "access is missing" (DefaultActions.jsx
  // destructures it as isTestAccessMissing) — i.e. it equals showBuy, not its
  // negation.
  const hideTestCTA =
    isStoreExclusive && hasAvailableForList
      ? resolveShowBuy(hasAccessForGate, availableFor, userSubscriptionType)
      : !hasAccessForGate;

  return { hideTestCTA, isTestAccessPresent, refetchUam, isUamValidating };
};

export default useHideTestCTA;
